export const COLLAPSE_MENU = 'COLLAPSE_MENU';
export const COLLAPSE_TOGGLE = 'COLLAPSE_TOGGLE';
export const FULL_SCREEN = 'FULL_SCREEN';
export const FULL_SCREEN_EXIT = 'FULL_SCREEN_EXIT';
export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const NAV_CONTENT_LEAVE = 'NAV_CONTENT_LEAVE';
export const NAV_COLLAPSE_LEAVE = 'NAV_COLLAPSE_LEAVE';

export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_FLASH_MESSAGE = 'SET_FLASH_MESSAGE';
export const SET_FLASH_MESSAGE_ERROR = 'SET_FLASH_MESSAGE_ERROR';

export const FETCH_USER_PROFILE = 'FETCH_USER_PROFILE';

export function fetchUserProfile(user) {
  return {
    type: FETCH_USER_PROFILE,
    profile: user
  }
}
